import template from './views/component.tpl.html';
import AlGuestlistLimitConfiguratorComponentController from './controllers/component';

/**
 * @ngdoc component
 * @name festzelt-os.modules.guestlists.component:al-guestlist-limit-configurator
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="festzelt-os.modules.guestlists">
 <file name="index.html">
 <al-guestlist-limit-configurator guestlist="{}"></al-guestlist-limit-configurator>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.modules.media')
    .component('alGuestlistLimitConfigurator', {
        bindings: {
            guestlist: '<',
            currentLimits: '<',
            enabledFields: '<',
            availableFields: '<',
            onLimitsUpdate: '&'
        },
        controller: AlGuestlistLimitConfiguratorComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-editor/general/limit-configurator/component.js